import { Button } from 'reactstrap'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import { PaymentMethodCalculationTypeBadge, PaymentMethodStatusBadge } from 'domains/payment-method/components'
import { PaymentMethodDataFormatter } from 'domains/payment-method/utils'

const propTypes = {
  paymentMethod: PropTypes.shape({
    id             : PropTypes.number,
    name           : PropTypes.string,
    category_label : PropTypes.string,
    gateway        : PropTypes.string,
    rate           : PropTypes.shape({
      calculation_type          : PropTypes.string,
      absolute_value_customer   : PropTypes.number,
      absolute_value_actual     : PropTypes.number,
      percentage_value_customer : PropTypes.number,
      percentage_value_actual   : PropTypes.number
    }),
    is_active: PropTypes.string
  }),
  onClickDetail         : PropTypes.func,
  onClickChangeIsActive : PropTypes.func
}

const PaymentMethodTableRow = ({
  paymentMethod,
  onClickDetail,
  onClickChangeIsActive
}) => {

  const {
    id,
    name,
    category_label,
    gateway,
    rate,
    is_active
  } = paymentMethod
  const buttonClassName = 'align-self-center my-1 mx-auto'

  const EnableButton = () => (
    <Button
      onClick={
        () => onClickChangeIsActive(id, is_active)
      }
      size='sm'
      color='success'
      className={ buttonClassName }
    >
      { 'Enable' }
    </Button>
  )

  const DisableButton = () => (
    <Button
      onClick={
        () => onClickChangeIsActive(id, is_active)
      }
      size='sm'
      color='danger'
      className= { buttonClassName }
    >
      { 'Disable' }
    </Button>
  )

  return (
    <tr>
      <td>{ id }</td>
      <td>{ name }</td>
      <td>{ category_label }</td>
      <td>{ StringUtil.titleCase(gateway) }</td>
      <td><PaymentMethodStatusBadge is_active={ is_active } /></td>
      <td><PaymentMethodCalculationTypeBadge calculationType={ rate?.calculation_type } /></td>
      <td>{ PaymentMethodDataFormatter.AbsoluteValue(rate?.absolute_value_customer) }</td>
      <td>{ PaymentMethodDataFormatter.AbsoluteValue(rate?.absolute_value_actual) }</td>
      <td>{ PaymentMethodDataFormatter.PercentageValue(rate?.percentage_value_customer) }</td>
      <td>{ PaymentMethodDataFormatter.PercentageValue(rate?.percentage_value_actual) }</td>
      <td className="d-flex flex-column">
        <Button
          size='sm'
          color='primary'
          className={ buttonClassName }
          onClick={
            () => onClickDetail(id)
          }
        >
          { 'Detail' }
        </Button>

        {
          is_active
            ? <DisableButton />
            : <EnableButton />
        }
      </td>
    </tr>
  )
}

PaymentMethodTableRow.propTypes = propTypes
export default PaymentMethodTableRow